module.exports = __webpack_public_path__ + "static/media/video-placeholder.24692490.jpg";